import { useContext } from 'react';
import LocalizationContext from "../LocalizationProvider/LocalizationContext";
export default function usePreferences() {
  var _useContext = useContext(LocalizationContext),
      preferences = _useContext.preferences;

  return preferences;
}